import { AfterViewInit, ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { filter, map, Subject, switchMap, takeUntil } from 'rxjs'
import { LeadSection, LeadSections, LeadSection_ } from '@appShared/services/lookup/lead-section'
import { AppSignals, CommonService /*, HybridWebviewInteropService*/ } from '@appShared/services'
import { SiteFooterComponent } from '@appShared/components/site-footer/site-footer.component'
import { InternalHeaderComponent } from '@appShared/components/internal-header/internal-header.component'
import { PublicHeaderComponent } from '@appShared/components/public-header/public-header.component'

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PublicHeaderComponent, InternalHeaderComponent, RouterOutlet, SiteFooterComponent]
})
export class ShellComponent implements AfterViewInit {
   private _router = inject(Router)
   private _activatedRoute = inject(ActivatedRoute)
   private _commonService = inject(CommonService)

   title = 'SWFC - LEAD'
   currentYear = new Date().getFullYear()
   sidebarToggle: HTMLElement
   private _ngDestroyed$ = new Subject()
   private _initialLeadSection = LeadSections.find(section => section.code === LeadSection_.Home)
   leadSection = { ...this._initialLeadSection }

   user = inject(AppSignals).currentUser
   //isDotNetInteroperable = toSignal(inject(HybridWebviewInteropService).isDotNetInteroperable$)

   constructor(
   ) {
      this._router.events
         .pipe(
            takeUntil(this._ngDestroyed$),
            filter(routeEvent => routeEvent instanceof NavigationEnd),
            map(() => this._activatedRoute),
            map(route => {
               while (route.firstChild) route = route.firstChild
               return route
            }),
            switchMap(firstChild => {
               return firstChild?.data
            }),
            map((data: LeadSection) => {
               return data
            })
         )
         .subscribe(data => {
            this.leadSection = { ...(data['section'] || this._initialLeadSection as LeadSection) }

         })
   }

   ngAfterViewInit() {
      this.sidebarToggle = document.getElementById('sidebar-toggle')
      if (this.sidebarToggle) {
         //Uncomment Below to persist sidebar toggle between refreshes
         //if (localStorage.getItem('sb|sidebar-toggle') === 'true') {
         //   document.body.classList.toggle('sb-sidenav-toggled')
         //}
         this.sidebarToggle.addEventListener('click', event => {
            event.preventDefault()
            document.body.classList.toggle('sb-sidenav-toggled')
            //localStorage.setItem(
            //   'sb|sidebar-toggle',
            //   document.body.classList.contains('sb-sidenav-toggled').toString()
            //)
         })
      }

      const sidebarWrapperLinks = document.body.querySelectorAll(
         '#sidebar-wrapper li > a'
      )
      if (sidebarWrapperLinks) {
         sidebarWrapperLinks.forEach(link => {
            link.addEventListener('click', event => {
               //only toggle sidebar if toggle button is visible (has offsetParent)
               if (this.sidebarToggle.offsetParent) {
                  document.body.classList.toggle('sb-sidenav-toggled')
                  //localStorage.setItem(
                  //   'sb|sidebar-toggle',
                  //   document.body.classList
                  //      .contains('sb-sidenav-toggled')
                  //      .toString()
                  //)
               }

               // issue with tooltips that won't go away when a link is clicked - remove it
               let tooltips = document.querySelectorAll("div[role='tooltip']")
               tooltips.forEach(item => item.remove())
            })
         })
      }
   }

   sayHi(args?: any) {
      const date = this._commonService.dateTime.formatDate(null, null, true)
      this._commonService.messageUser(`${date}: ${(args?.title || 'whatevs')}`)
   }

}
